<template>
  <div v-if="symbol">
    <NBox
      v-if="relevantSymbolIsin !== symbol.isin"
      v-gid="{
        module: 'symbol',
        screen: 'home',
        section: 'symbolDetailSearch',
        component: 'searchResult',
      }"
      active-style
      elevation="none"
      class="flex justify-between items-center py-2 px-3 mb-2 border border-neutral-secondary hover:bg-neutral-secondary"
      @click="handleClick"
      @mouseenter="toggle(true)"
      @mouseleave="toggle(false)"
    >
      <div class="flex items-center">
        <div class="flex flex-col">
          <Retail v-if="symbol.isin" :isin="symbol.isin">
            <!-- eslint-disable -->
            <NText
              v-if="symbol.name"
              variant="caption1"
              weight="bold"
              v-html="highlightText(symbol.name)"
            />
          </Retail>

          <NText
            v-if="symbol.title"
            variant="caption2"
            class="text-neutral-secondary"
            v-html="highlightText(symbol.title)"
          />
        </div>
      </div>

      <NegarCloseIcon
        v-if="showCloseIcon && hovered"
        class="rounded-full hover:bg-neutral-secondary active:bg-neutral-primary-press cursor-pointer"
        @click.stop="emit('removeRecentItem')"
      />
    </NBox>
  </div>
</template>

<script setup lang="ts">
//todo Security Note: https://vuejs.org/api/built-in-directives.html#v-html
//todo use DOMPurify: https://www.npmjs.com/package/dompurify
import { NegarCloseIcon } from '@negar/icons';
import { useToggle } from '@libs/use';
import { SymbolResult } from '@libs/api-reference';

import { Retail } from '@/modules/symbol';

const props = withDefaults(
  defineProps<{
    symbol: SymbolResult | null;
    term?: string | number;
    relevantSymbolIsin?: string;
    showCloseIcon?: boolean;
  }>(),
  {
    symbol: null,
    term: '',
    relevantSymbolIsin: '',
    showCloseIcon: false,
  }
);

const { toggle, active: hovered } = useToggle();

const emit = defineEmits(['handleSymbolClick', 'removeRecentItem']);

const highlightText = (text: string): string =>
  text.replace(
    new RegExp(String(props.term), 'ig'),
    (matched: string): string => {
      return `<span class="text-brand-primary">${matched}</span>`;
    }
  );

const handleClick = () => {
  if (props.symbol) {
    emit('handleSymbolClick', props.symbol);
  }
};
</script>
